<div class="logo">
  <img [src]="'assets/images/logo.svg'">
  Token de punto de trabajo inválido. Contacte Administrador.
</div>
